import { useEffect, useState } from 'react';
import useWidth from '../components/Hooks/useWidth';

const HEIGHT_OFFSET = 100;

function useMobileKeyboardDetector() {
  const { mobileWidth } = useWidth();
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  const handleVisualViewportChange = () => {
    setIsKeyboardOpen(
      !!window.visualViewport && window.visualViewport.height < window.innerHeight - HEIGHT_OFFSET,
    );
  };

  useEffect(() => {
    if (mobileWidth && window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleVisualViewportChange);
      window.visualViewport.addEventListener('scroll', handleVisualViewportChange);
    }

    return () => {
      window.visualViewport?.removeEventListener('resize', handleVisualViewportChange);
      window.visualViewport?.removeEventListener('scroll', handleVisualViewportChange);
    };
  }, [mobileWidth]);

  return { isKeyboardOpen };
}

export default useMobileKeyboardDetector;
